import { jsx } from "react/jsx-runtime";
import { assert, isNonEmptyString } from "@contember/utilities";
import { createContext, useContext, useMemo, useRef, memo } from "react";
import { noopScopedConsole, isNoopScopedConsole } from "./Constants.js";
function createPrefixedConsole(message, prefixedConsole) {
  return {
    error: function error(...parameters) {
      (prefixedConsole ?? console).error(message, ...parameters);
    },
    errored: function errored(message2, value) {
      (prefixedConsole ?? console).error(message2, value);
      return value;
    },
    log: function log(...parameters) {
      (prefixedConsole ?? console).log(message, ...parameters);
    },
    logged: function logged(message2, value) {
      (prefixedConsole ?? console).log(message2, value);
      return value;
    },
    trace: function trace(...parameters) {
      (prefixedConsole ?? console).trace(message, ...parameters);
    },
    traced: function traced(message2, value) {
      (prefixedConsole ?? console).trace(message2, value);
      return value;
    },
    warn: function warn(...parameters) {
      (prefixedConsole ?? console).warn(message, ...parameters);
    },
    warned: function warned(message2, value) {
      (prefixedConsole ?? console).warn(message2, value);
      return value;
    }
  };
}
const ScopedConsoleContext = createContext(null);
ScopedConsoleContext.displayName = "ScopedConsoleContext";
function parentScopedConsoleOrNone(parentConsole) {
  return isNoopScopedConsole(parentConsole) ? void 0 : parentConsole;
}
const useScopedConsoleRef = (prefix, override) => {
  assert("prefix is non-empty string", prefix, isNonEmptyString);
  const parentConsole = parentScopedConsoleOrNone(useContext(ScopedConsoleContext));
  const scopedConsole = useMemo(() => {
    if (override !== false && (parentConsole || override)) {
      return createPrefixedConsole(prefix, parentConsole);
    } else {
      return noopScopedConsole;
    }
  }, [override, parentConsole, prefix]);
  const ref = useRef(scopedConsole);
  ref.current = scopedConsole;
  return ref;
};
const DebugChildren = memo(({ active = true, children, id }) => {
  const parentScopedConsole = parentScopedConsoleOrNone(useContext(ScopedConsoleContext));
  const console2 = active && id ? createPrefixedConsole(id, parentScopedConsole) : noopScopedConsole;
  return /* @__PURE__ */ jsx(ScopedConsoleContext.Provider, { value: active ? console2 : noopScopedConsole, children });
});
DebugChildren.displayName = "DebugChildren";
export {
  DebugChildren,
  ScopedConsoleContext,
  useScopedConsoleRef
};
//# sourceMappingURL=Context.js.map
